import { Chart } from "src/app/components";
import { useSiteStatChart } from "src/app/hooks";

const RDChartContainer = ({ moneySiteId }: { moneySiteId?: number }) => {
    const { siteStatsChart } = useSiteStatChart("RD", moneySiteId);
    return <Chart color="#9B59B6" title="RD" data={siteStatsChart} />;
};

export default RDChartContainer;
